import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';

function MobileMenu({ isOpen, onClose }) {
    const [activeMenu, setActiveMenu] = useState(null);
    const [activeShopMenu, setActiveShopMenu] = useState(false); // Shop submenu state
    const menuRefs = useRef({});

    // Toggle dropdown menu
    const toggleMenu = (index) => {
        if (index !== 6) {
            setActiveMenu(activeMenu === index ? null : index);
        }
    };

    // Handle Shop menu separately
    const toggleShopMenu = (e) => {
        e.stopPropagation(); // Prevent menu from closing
        setActiveShopMenu(!activeShopMenu);
    };

    // Apply height animation when activeMenu changes
    useEffect(() => {
        Object.keys(menuRefs.current).forEach((key) => {
            const submenu = menuRefs.current[key];
            if (submenu) {
                submenu.style.height = activeMenu == key ? `${submenu.scrollHeight}px` : "0px";
            }
        });
    }, [activeMenu]);

    return (
        <div className={`th-menu-wrapper onepage-nav ${isOpen ? "th-body-visible" : ""}`}
            style={{ visibility: isOpen ? "visible" : "hidden" }}>

            <div className="th-menu-area text-center">
                <button className="th-menu-toggle" onClick={onClose} aria-label="Close">
                    <i className="fal fa-times" />
                </button>

                <div className="mobile-logo">
                    <Link to="/" onClick={onClose}>
                        <img src="/assets/img/koorditel.png" alt="PetaWiFi" />
                    </Link>
                </div>

                <div className="th-mobile-menu">
                    <ul>
                        {/* Beranda */}
                        <li>
                            <Link to="/" onClick={onClose}>
                                <i className="fas fa-home"></i> Beranda
                            </Link>
                        </li>

                        {/* Statistik */}
                        <li>
                            <Link to="/statistics" onClick={onClose}>
                                <i className="fas fa-chart-bar"></i> Statistik
                            </Link>
                        </li>

                        {/* Tentang PetaWiFi */}
                        <li>
                            <Link to="/about" onClick={onClose}>
                                <i className="fas fa-info-circle"></i> Tentang PetaWiFi
                            </Link>
                        </li>

                        {/* Kontak & Bantuan */}
                        <li>
                            <Link to="/contact" onClick={onClose}>
                                <i className="fas fa-envelope"></i> Kontak & Bantuan
                            </Link>
                        </li>

                        {/* Panel Admin */}
                        <li>
                            <Link to="/admin" onClick={onClose}>
                                <i className="fas fa-chart-line"></i> Panel Admin
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default MobileMenu;
